import React from 'react';
import ReactSelect from 'react-select';
import CreatableSelect from 'react-select/creatable';
import PropTypes from 'prop-types';
import withLocalization from '../../higherOrderComponents/withLocalization';
import { allowedMessageProps } from '../../lists/SystemMessages';
import { allowedSelectOptionTypes, allowedReactSelectValueTypes } from './_allowedPropTypes';

const InputFieldSelect = ({
  translate,
  inputAttributes,
  message,
  label,
  description,
  options,
  isMulti = false,
  isCreatable = false,
  noOptionsMessage,
  onInputChange,
  createOptionMessage,
  customChangeHandler
}) => {
  const { value: passedValue } = inputAttributes;

  if (isMulti !== Array.isArray(passedValue)) {
    throw new Error(
      `ERROR: Select expects string-typed value or array-typed value and isMulti param to be "true",
      but got ${typeof (passedValue)}-typed value and isMulti:${isMulti.toString()}.`
    );
  }

  // passedValue is an array of strings if isMulti is true, otherwise only a string
  const finalValue = !isMulti
    ? options.find(({ value }) => value === passedValue)
    : passedValue.map(passedValueMember => options.find(({ value: optionValue }) => optionValue === passedValueMember));

  const finalInputAttributes = {
    ...inputAttributes,
    className: 'react-select-wrap',
    value: finalValue,
    'aria-invalid': !!message
  };

  if (!label) {
    finalInputAttributes.title = description;
  }

  if (customChangeHandler) {
    finalInputAttributes.onChange = function ({ value }) {
      customChangeHandler({ value });
    };
  }

  const reactSelectProps = {
    options,
    isMulti,
    classNamePrefix: 'react-select',
    onInputChange,
    noOptionsMessage: userInput => (noOptionsMessage
      ? noOptionsMessage(userInput)
      : translate('input-select-noOptions-text'))
  };

  if (isCreatable) {
    reactSelectProps.onChange = function (newValue) {
      if (customChangeHandler) {
        customChangeHandler({ value: newValue });
      }

      else {
        inputAttributes.onChange(newValue);
      }
    };

    reactSelectProps.formatCreateLabel = userInput => (createOptionMessage
      ? createOptionMessage(userInput)
      : translate('input-select-createOption-text', { userInput }));
  }

  const SelectComponent = isCreatable ? CreatableSelect : ReactSelect;
  const result = <SelectComponent {...finalInputAttributes} {...reactSelectProps} />;

  return <div className='react-select-outer-div'>{result}</div>;
};

InputFieldSelect.propTypes = {
  inputAttributes: PropTypes.shape({
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    value: PropTypes.oneOfType(allowedReactSelectValueTypes).isRequired
  }).isRequired,
  label: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
    PropTypes.bool
  ]),
  description: PropTypes.string.isRequired,
  message: PropTypes.shape(allowedMessageProps),
  setFieldValue: PropTypes.func.isRequired,
  isMulti: PropTypes.bool,
  isCreatable: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.oneOfType(allowedSelectOptionTypes)
  ).isRequired,
  noOptionsMessage: PropTypes.func,
  onInputChange: PropTypes.func,
  createOptionMessage: PropTypes.func,
  customChangeHandler: PropTypes.func
};

export default withLocalization(InputFieldSelect, 'elements/customInput');